(function () {
  var stages = [];

  function collect() {
    stages = Array.prototype.slice.call(document.querySelectorAll('[data-kaamo-scroll-build]')).map(function (stage) {
      return {
        stage: stage,
        image: stage.querySelector('[data-kaamo-reveal]'),
        line: stage.querySelector('[data-kaamo-drawline]'),
      };
    });
  }

  function update() {
    var vh = window.innerHeight;
    var endAt = vh * 0.3;

    stages.forEach(function (entry) {
      var rect = entry.stage.getBoundingClientRect();
      if (rect.bottom < 0 || rect.top > vh) return; // skip offscreen work

      var progress = (vh - rect.top) / (vh - endAt);
      progress = Math.max(0, Math.min(1, progress));

      if (entry.image) {
        entry.image.style.clipPath = 'inset(0 0 ' + (1 - progress) * 100 + '% 0)';
      }
      if (entry.line) {
        entry.line.style.transform = 'translateY(' + progress * entry.stage.offsetHeight + 'px)';
        entry.line.style.opacity = progress >= 0.98 ? '0' : '1';
      }
    });

    ticking = false;
  }

  var ticking = false;
  function onScroll() {
    if (!ticking) {
      ticking = true;
      requestAnimationFrame(update);
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    collect();
    update();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
  });
})();
